<template>
  <div>
    <slot name="header" />
    <apexchart
      id="pie-chart"
      class="w-100"
      :height="height"
      :options="chartOptions"
      :series="series"
    />
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import { ApexChartsLocale } from '@/data/models/ApexchartsLocale'
import i18n from '@/plugins/i18n'

export default {
  name: 'PieChart',
  components: {
    apexchart: VueApexCharts
  },
  props: {
    series: {
      type: Array,
      required: true
    },
    hideLabels: {
      type: Boolean,
      default: false
    },
    colors: {
      type: Array,
      default: () => ['#008FFB', '#00E396', '#FEB019', '#FF4560', '#775DD0']
    },
    height: {
      type: String,
      default: '400'
    },
    showLegend: {
      type: Boolean,
      default: false
    },
    contentClass: {
      type: String,
      default: null
    },
    xaxis: {
      type: Object,
      default: () => ({
        labels: {
          show: true
        }
      })
    },
    yaxis: {
      type: Object,
      default: () => ({})
    },
    labels: {
      type: Array,
      default: null
    }
  },
  computed: {
    colorss() {
      return this.$vuetify.theme.secondary
    },
    chartOptions() {
      return {
        colors: this.colors,
        chart: {
          height: this.height,
          toolbar: {
            show: false
          },
          type: 'pie',
          locales: ApexChartsLocale,
          defaultLocale: i18n.locale
        },
        labels: this.labels,
        legend: {
          show: !this.hideLabels
        },
        xaxis: this.xaxis,
        yaxis: this.yaxis
      }
    }
  }
}
</script>
